// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1UVfi","Success":"Button_Success__2358h","btn":"Button_btn__35VHk"};